export const environment = {
  production: true,
  basePath: '__ApplicationUrl__',
  identityAuthority: 'https://identity.stego.de',
  version: {
    environment: '__VersionEnvironment__',
    number: '__VersionNumber__',
  },
};
